module.exports = __webpack_public_path__ + "static/media/icon-eye-hide.4b700124.svg";